<div *ngIf="volumeDiscounts && volumeDiscounts.length > 0" class="space-y-2 sm:space-y-3">
  <!-- Simplified Header -->
  <h3 class="font-semibold text-sm sm:text-base text-gray-800">{{ 'Rabat ilościowy' | translate }}</h3>

  <!-- Simple Discount Tiers - Responsive layout -->
  <div class="flex gap-2 sm:gap-3 overflow-x-auto pb-2">
    <button
      *ngFor="let discount of volumeDiscounts"
      (click)="selectVolumeDiscount(discount)"
      [disabled]="isActiveDiscount(discount)"
      class="flex-shrink-0 px-3 py-2 sm:px-4 sm:py-2 border rounded-lg text-xs sm:text-sm font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-orange-500 min-w-0"
      [class]="isActiveDiscount(discount) ?
        'bg-gray-500 text-white border-gray-500' :
        'bg-white text-gray-700 border-gray-300 hover:border-orange-400 hover:bg-orange-50 cursor-pointer'"
    >
      <div class="text-center whitespace-nowrap">
        <div class="font-medium">{{ discount.label || ('od ' + discount.minQuantity + ' szt.') }}</div>
        <div class="text-xs mt-0.5 sm:mt-1">{{ discount.discountPercent | number:'1.0-0' }}{{ '% zniżki' | translate }}</div>
      </div>
    </button>
  </div>
</div>
